<template>
  <div class="space-y-1">
    <div
      @click="() => option.alert ? windowStore.setAlert({ ...option.alert }) : modelValue = option.value"
      class="flex items-center space-x-2.5 py-2 px-3 bg-light-200 dark:bg-dark-700 rounded-lg cursor-pointer transition"
      v-for="option in options"
    >
      <div class="shrink-0">
        <ImageEmoji :name="option.emoji" size="sm" class="size-5" :class="[ modelValue === option.value ? '' : 'saturate-0']" v-if="option.emoji" />
      </div>
      <div class="grow">
        <p class="font-bold text-base leading-tight" :class="[ modelValue === option.value ? 'text-light-950 dark:text-dark-50' : 'text-light-800 dark:text-dark-400']">
          {{ option.label }}
        </p>
        <p class="text-sm font-medium leading-tight" :class="[ modelValue === option.value ? 'text-light-800 dark:text-dark-300' : 'text-light-600 dark:text-dark-500']" v-if="option.content">
          {{ option.content }}
        </p>
      </div>
      <div class="shrink-0 rounded-full flex items-center justify-center size-7 bg-light-800 dark:bg-dark-900">
        <div class="size-[1.2rem] bg-cover rounded-full duration-200 " :style="{ backgroundImage: `url(${gradientBase})` }" :class="[ modelValue === option.value ? 'ease-out' : 'ease-in scale-75 opacity-0']" />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import WindowStore from '@/store/window'
import { Alert } from '@/store/window'
import gradientBase from '@/assets/img/gradients/hard/gradient-2.jpg'

const props = withDefaults(defineProps<{
  options: {
    label: string
    content?: string
    value: string | number | boolean
    alert?: Alert
    emoji?: string
    isDisabled?: boolean
  }[]
}>(), {
  options: () => [],
})

const windowStore = WindowStore()

const modelValue = defineModel<string | number | boolean>()
</script>